<wk-icon-member-sprite-pds3 />
<wk-icon-active-member-sprite-pds3 />

@for (member of cardModalService.members(); track member.id) {
    <div
        [id]="'t1-member-' + sanatizeId(member.id)"
        class="wk-cm__west-panel__t1__member"
        [class.wk-cm__west-panel__t1__member--active]="member.currentMember"
        [class.wk-cm__west-panel__t1__member--spouse]="member.memberType === 'Spouse'"
        [class.wk-cm__west-panel__t1__member--dependant]="member.memberType === 'Dependant'"
        [class.wk-cm__west-panel__t1__member--taxpayer]="member.memberType === 'Taxpayer'"
        (click)="handleMemberNameClick(member.id)"
        (keydown.enter)="handleMemberNameClick(member.id)"
        aria-hidden="true"
    >
        <div class="wk-cm__west-panel__t1__member-content">
            <icon-pds3 [name]="member.currentMember ? 'wk-icon-active-member' : 'wk-icon-member'" />
            <span class="wk-cm__west-panel__t1__member-name wk-cm__west-panel--hide-on-collapse">{{ member.name }}</span>
        </div>
    </div>

    @if (cardModalService.isSidebarCollapsed()) {
        <tooltip-pds3
            mode="description"
            [openDelay]="600"
            [closeDelay]="50"
            position="right"
            [targetSelector]="'#t1-member-' + sanatizeId(member.id)"
            class="wk-cm__west-panel__t1__member-tooltip"
        >
            {{ member.name }}
        </tooltip-pds3>
    }
}

@if (!isMembersReturnStatusSame) {
    <div class="wk-cm__west-panel__t1__info">
        <icon-pds3 name="wk-icon-filled-caution" />
        <span class="wk-cm__west-panel__t1__info-title wk-cm__west-panel--hide-on-collapse">{{
            "CardModal.FamilyMembersDifferenceDisplayNote" | translate
        }}</span>
    </div>

    @if (cardModalService.isSidebarCollapsed()) {
        <tooltip-pds3
            mode="description"
            [openDelay]="600"
            [closeDelay]="50"
            position="right"
            [placementOptions]="{ offsets: { right: { topOffset: 17 } } }"
            targetSelector=".wk-cm__west-panel__t1__info"
        >
            {{ "CardModal.FamilyMembersDifferenceDisplayNote" | translate }}
        </tooltip-pds3>
    }
}
